export const defaultOptions = {
    zoom: true
};

export class PhotoSwitcher {
    constructor(options = {}) {
        let switchPhoto = $('.js-ab-slide_photo'),
            elevateZoom = switchPhoto.data('elevateZoom'),
            thumbs = $('.js-ab-slider_thumb'),
            thumbPhoto = thumbs.find('.slide.active'),
            self = this;

        this.options = Object.assign({}, defaultOptions, options);

        if (this.options.zoom) {
            if ($(window).width() >= TABLET_BREAKPOINT) {
                if (elevateZoom) {
                    elevateZoom.changeState('enable');
                } else {
                    let i = 0;
    
                    switchPhoto.each(function () {
                        $(this).elevateZoom({
                            zoomWindowFadeIn: 300,
                            zoomWindowFadeOut: 300,
                            lensFadeIn: 300,
                            lensFadeOut: 300,
                            zoomWindowHeight: 600,
                            zoomWindowWidth: 400,
                            zoomWindowOffetx: 20,
                            borderSize: 1,
                            zoomLevel: 2,
                            scrollZoom: true,
                            cursor: 'url("/assets/images/i-cursor-zoom-in.svg"), pointer',
                            onZoomedImageLoaded: function () {
                                i++;
    
                                if (i === switchPhoto.length) {
                                    zoomContainerInit();
                                }
                            },
                        });
                    });
                }
            } else if (elevateZoom) {
                elevateZoom.changeState('disable');
            }
        }
        

        $('.js-video').on('click', function () {
            $('.js-ab-slider_full > div').removeClass('active');
            $('.js-ab-slider_full video').parent().addClass('active');
            $('.js-ab-slider_full video').trigger('play');

            if (self.options.zoom) {
                if (switchPhoto.data('elevateZoom')) {
                    switchPhoto.data('elevateZoom').changeState('disable');
                    $('.zoomContainer').hide();
                }
            }

            thumbPhoto.removeClass('active');
            thumbPhoto = $(this);
            thumbPhoto.addClass('active');
        });

        thumbs.find('.slide').not('.js-video').on('click', function () {
            $('.js-ab-slider_full video').trigger('pause');

            if (self.options.zoom) {
                if (switchPhoto.data('elevateZoom')) {
                    switchPhoto.data('elevateZoom').changeState('enable');
                }
            }

            if ($(this).data('id') == thumbPhoto.data('id')) {
                return;
            }

            thumbPhoto.removeClass('active');
            thumbPhoto = $(this);
            thumbPhoto.addClass('active');

            $('.js-ab-slider_full > div').removeClass('active');

            $('.zoomContainer').hide();

            switchPhoto.each((i, img) => {
                const srcFromFull = img.dataset.zoomImage.toLowerCase();
                const srcFromThumb = thumbPhoto.data('zoom-image').toLowerCase();

                if (srcFromFull === srcFromThumb) {
                    img.closest('.slide').classList.add('active');

                    $('.zoomContainer .zoomWindow').each((i, item) => {
                        const bgImage = item.style.backgroundImage.toLowerCase();

                        if (bgImage.indexOf(srcFromFull) > -1) {
                            item.closest('.zoomContainer').style.display = 'block';
                        }
                    });
                }
            }); 

        });

        $('.js-ab-slider_full > div').first().addClass('active');

        function zoomContainerInit() {
            $('.zoomContainer').hide();

            $('.zoomContainer .zoomWindow').each((i, item) => {
                const bgImage = item.style.backgroundImage.toLowerCase();

                if (bgImage.indexOf($('.js-ab-slider_full > div img').first().data('zoom-image').toLowerCase()) > -1) {
                    item.closest('.zoomContainer').style.display = 'block';
                }
            });
        }
    }
}
